export default __webpack_public_path__ + "static/media/Smile.2ee53716.svg";